<template>
  <v-container
    grid-list-xl
    fluid
  >
    <LoadingState
      :loading="loading"
      color="primary"
    />
    <v-layout
      v-if="!loading"
      row
      wrap
    >
      <v-flex
        xs12
      >
        <h4 class="text--secondary">
          {{ $t('Used {0} times', [discount.total_times_used]) }}
        </h4>
      </v-flex>
      <v-flex
        xs12
        md8
      >
        <DiscountSingleSettings :item="discount"/>
        <DiscountCustomerGroups :item="discount"/>
        <DiscountTargetConditions
          v-if="discount.target === 'items'"
          :item="discount"
        />
        <DiscountSingleConditions :item="discount" />
      </v-flex>

      <v-flex
        xs12
        md4
      >
        <DiscountSingleDetails :item="discount"/>
        <DiscountSingleDates :item="discount"/>
        <DiscountSingleCoupon :item="discount"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import LoadingState from '@/components/LoadingState'
import DiscountSingleDetails from './DiscountSingleDetails'
import DiscountSingleConditions from './DiscountSingleConditions'
import DiscountTargetConditions from './DiscountTargetConditions'
import DiscountSingleDates from './DiscountSingleDates'
import DiscountSingleCoupon from './DiscountSingleCoupon'
import DiscountSingleSettings from './DiscountSingleSettings'
import DiscountCustomerGroups from './DiscountCustomerGroups'

export default {
  name: 'DiscountSingle',

  components: {
    LoadingState,
    DiscountSingleDetails,
    DiscountSingleConditions,
    DiscountTargetConditions,
    DiscountSingleDates,
    DiscountSingleCoupon,
    DiscountSingleSettings,
    DiscountCustomerGroups
  },
  props: {
    discount: {
      type: Object,
      required: true
    }
  },
  computed: {
    loading () {
      return Object.entries(this.discount).length === 0
    }
  }
}
</script>
